var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReservedSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6398DE"
    },
    d: "M118.098,374.302L78.713,131.398c-1.547-9.535-9.779-16.542-19.439-16.542h-0.197 c-9.658,0-17.892,7.007-19.439,16.542L0.254,374.302c-0.924,5.699,0.7,11.516,4.441,15.914c3.742,4.397,9.224,6.929,14.998,6.929 h78.966c5.772,0,11.256-2.534,14.998-6.929C117.398,385.82,119.022,380.001,118.098,374.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6E5F6"
    },
    d: "M511.747,374.302l-39.385-242.905c-1.547-9.535-9.779-16.542-19.439-16.542H59.276 c-5.772,0-11.256,2.535-14.998,6.93c-3.742,4.398-5.365,10.215-4.441,15.914l39.385,242.905c1.547,9.535,9.779,16.54,19.439,16.54 h393.648c5.774,0,11.256-2.534,14.998-6.929C511.048,385.82,512.672,380.001,511.747,374.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCD6F2"
    },
    d: "M511.747,374.302l-39.385-242.905c-1.547-9.535-9.779-16.542-19.439-16.542H253.319l45.77,282.289 h193.22c5.774,0,11.256-2.534,14.998-6.929C511.048,385.82,512.672,380.001,511.747,374.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CB7E8"
    },
    d: "M393.847,275.695H157.539c-10.875,0-19.692-8.818-19.692-19.692c0-10.877,8.817-19.692,19.692-19.692 h236.308c10.875,0,19.692,8.816,19.692,19.692C413.539,266.877,404.722,275.695,393.847,275.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6398DE"
    },
    d: "M393.847,236.31H273.011l6.386,39.385h114.45c10.875,0,19.692-8.818,19.692-19.692 C413.539,245.126,404.722,236.31,393.847,236.31z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedSvgrepoCom);
export default __webpack_public_path__ + "static/media/reserved-svgrepo-com.fd984d5b8ebb6563c3c19d0ed10d8ef8.svg";
export { ForwardRef as ReactComponent };